import { LocationsModel } from "./interfaces";

import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";
import types from "./types";

export const locationsCreate = (data: LocationsModel, onResponse?: Function) =>
    request(
        types.STORE_REQUEST,
        types.STORE_FAILED,
        types.STORE_SUCCESS,
        "locationsCreate",
        {
            data,
        },
        onResponse,
        undefined,
        "orderv2",
    );

export const locationsDelete = (id: number, onResponse?: Function) =>
    request(
        types.DESTROY_REQUEST,
        types.DESTROY_FAILED,
        types.DESTROY_SUCCESS,
        "locationsDelete",
        {
            url: {
                id,
            },
        },
        onResponse,
        undefined,
        "orderv2",
    );

export const locationsFetch = (config?: AxiosRequestConfig) =>
    request(
        types.FETCH_REQUEST,
        types.FETCH_FAILED,
        types.FETCH_SUCCESS,
        "locationsFetch",
        {
            config,
        },
        undefined,
        undefined,
        "orderv2",
    );

export const locationsGet = (
    id: number,
    config?: AxiosRequestConfig,
    onResponse?: Function,
) =>
    request(
        types.GET_REQUEST,
        types.GET_FAILED,
        types.GET_SUCCESS,
        "locationsGet",
        {
            config,
            url: {
                id,
            },
        },
        onResponse,
        undefined,
        "orderv2",
    );

export const locationsPatch = (
    id: number,
    data: any,
    onResponse?: Function,
) => {
    return request(
        types.PATCH_REQUEST,
        types.PATCH_FAILED,
        types.PATCH_SUCCESS,
        "locationsPatch",
        {
            data,
            url: { id },
        },
        onResponse,
        undefined,
        "orderv2",
    );
};

export const locationsTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_UPDATE,
    action,
    data,
});

export const locationsUpdate = (
    id: number,
    data: any,
    onResponse?: Function,
) => {
    return request(
        types.UPDATE_REQUEST,
        types.UPDATE_FAILED,
        types.UPDATE_SUCCESS,
        "locationsUpdate",
        {
            data,
            url: { id },
        },
        onResponse,
        undefined,
        "orderv2",
    );
};
